export default "__VITE_ASSET__CN5tI5Rx__"